import React, { useState } from 'react';
import { Column } from 'rbx';
import { isNull } from 'lodash';
import styled from 'styled-components';

import { Select } from '../../../../components/elements';

import DiscountValueInput from './DiscountValueInput';

import PriceInput from './PriceInput';

const Container = styled(Column.Group)`
  border-bottom: 1px solid #b0b0b0;
  background-color: #fbf8f8;
`;

const RemoveWrapper = styled(Column)`
  cursor: pointer;
  color: #ee2a7b;
  padding-top: 18px;
`;

const calculate = (price, discountValue, discountType) => {
  if (
    isNull(price) ||
    isNull(discountValue) ||
    discountValue === 0 ||
    discountValue === '' ||
    discountValue === '0'
  ) {
    return { new_price: price, savings: 0 };
  }
  if (discountType === 'PRICE') {
    return {
      new_price: parseFloat(price - discountValue).toFixed(2),
      savings: parseFloat(discountValue).toFixed(2),
    };
  }
  return {
    new_price: parseFloat(price - (discountValue * price) / 100).toFixed(2),
    savings: parseFloat((discountValue * price) / 100).toFixed(2),
  };
};

const ItemWithoutVariant = ({
  setFieldValue,
  menu_item,
  selectedLinkIds,
  item_link_id,
  setItemLink,
  itemLink,
  isBogoDeal,
}) => {
  const discountTypeOptions = [
    { value: 'PERCENTAGE', label: '% rate' },
    { value: 'PRICE', label: 'flat rate' },
  ];

  const [discountType, setDiscountType] = useState(
    itemLink.type
      ? discountTypeOptions.find(ele => ele.value === itemLink.type)
      : discountTypeOptions[0],
  );
  const [discountValue, setDiscountValue] = useState(itemLink.value || 0);

  return (
    <>
      <Container>
        <Column size={2}>{itemLink.name}</Column>
        <Column size={10} style={{ fontSize: '13px' }}>
          <Column.Group>
            {isBogoDeal ? (
              <>
                <Column size={2} />
                <Column size={2} />
                <Column size={2} />
                <Column size={2} />
                <Column size={2} />
                <RemoveWrapper size={2}>
                  <span
                    onClick={() => {
                      const modifiedMenuItem = menu_item.filter(
                        e => e.item_link_id !== item_link_id,
                      );
                      setFieldValue('menu_item', modifiedMenuItem);
                      const modifiedSelectedLinkIds = selectedLinkIds.filter(
                        ele => ele !== item_link_id,
                      );
                      setFieldValue('selectedLinkIds', modifiedSelectedLinkIds);
                    }}
                  >
                    Remove
                  </span>
                </RemoveWrapper>
              </>
            ) : (
              <>
                <Column size={2}>
                  <PriceInput value={itemLink.menu_item_price || 0} />
                </Column>
                <Column size={2} style={{ paddingTop: '8px' }}>
                  <Select
                    value={discountType}
                    options={discountTypeOptions}
                    onChange={value => {
                      setDiscountType(value);
                      const { new_price, savings } = calculate(
                        itemLink.menu_item_price,
                        discountValue,
                        value.value,
                      );
                      setItemLink(prev => ({
                        ...prev,
                        type: value.value,
                        new_price,
                        savings,
                      }));
                    }}
                    disabled={isNull(itemLink.menu_item_price)}
                  />
                </Column>
                <Column size={2}>
                  <DiscountValueInput
                    value={discountValue}
                    price={itemLink.menu_item_price}
                    discountType={discountType?.value}
                    onChange={e => {
                      setDiscountValue(e.target.value);
                      const { new_price, savings } = calculate(
                        itemLink.menu_item_price,
                        e.target.value,
                        discountType?.value,
                      );
                      setItemLink(prev => ({
                        ...prev,
                        value: parseFloat(e.target.value || 0),
                        new_price,
                        savings,
                      }));
                    }}
                    disabled={isNull(itemLink.menu_item_price)}
                  />
                </Column>
                <Column size={2}>
                  <PriceInput value={itemLink.new_price} />
                </Column>
                <Column size={2}>
                  <PriceInput value={itemLink.savings} />
                </Column>
                <RemoveWrapper size={2}>
                  <span
                    onClick={() => {
                      const modifiedMenuItem = menu_item.filter(
                        e => e.item_link_id !== item_link_id,
                      );
                      setFieldValue('menu_item', modifiedMenuItem);
                      const modifiedSelectedLinkIds = selectedLinkIds.filter(
                        ele => ele !== item_link_id,
                      );
                      setFieldValue('selectedLinkIds', modifiedSelectedLinkIds);
                    }}
                  >
                    Remove
                  </span>
                </RemoveWrapper>
              </>
            )}
          </Column.Group>
        </Column>
      </Container>
    </>
  );
};

export default ItemWithoutVariant;
